<template>
  <v-card v-if="!childjob.New" :width="'100%'" class="mb-3 mx-0" v-click-outside="unfocusEntireCard">
    <v-row no-gutters>

      <v-col cols="0">
        <slotted-card :editable="true" :title="childjob.Machine.DisplayName" :fontsize="'h4'" :headerclass="'py-0'"
          :headertextclass="'nowrapheader'" :externalEditTrigger="editmodetrigger" @editMode="setEditMode"
          @valid="setValid">

          <template v-slot:headertitle>
            <MachineLi :machine="childjob.Machine" :disabled="true" style="padding-left: 0px !important;" />
          </template>

          <template v-slot:headerbtns>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="jobsdialogtrigger++" v-bind="attrs" v-on="on" icon color="primary">
                  <v-icon v-text="'mdi-briefcase-search'" />
                </v-btn>
              </template>
              <span v-text="$t('servicesystem.common_objects.customer.other_jobs')" />
            </v-tooltip>
          </template>

          <template v-slot:content>
            <v-row no-gutters>
              <v-col :cols="0">
                <v-container>
                  <v-row>
                    <v-col :cols="isPhoneBool ? 12 : undefined" style="background-color: #f9f9f9; overflow-y: auto;">
                      <QTextArea v-model="editObject.CustomerComment"
                        :label="$t('servicesystem.common_objects.machine.edit.customer_comment')"
                        :externaledit="editMode" :backgroundcolor="'#f9f9f9'"
                        :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampJobDescription"
                        @FocusState="editMode ? null : editmodetrigger++">
                      </QTextArea>
                    </v-col>
                    <v-col :cols="isPhoneBool ? 12 : undefined" style="background-color: #edfffd; overflow-y: auto;">
                      <QTextArea v-model="editObject.InvoiceComment"
                        :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampInvoiceComment"
                        :label="$t('servicesystem.common_objects.machine.edit.invoice_comment')"
                        :externaledit="editMode" :backgroundcolor="'#edfffd'"
                        @FocusState="editMode ? null : editmodetrigger++">
                      </QTextArea>
                    </v-col>
                  </v-row>
                </v-container>
                <v-row no-gutters class="pt-2">
                  <v-col class="px-3">
                    <SupplierFailureCodeSelect v-model="editObject.SupplierFailureCodeId" allowCreate
                      :filter="{ SupplierIdList: SupplierId ? [SupplierId] : undefined }" clearable hideIcon
                      :disabled="!SupplierId" :externaledit="editMode"
                      @FocusState="editMode ? null : editmodetrigger++">
                    </SupplierFailureCodeSelect>
                  </v-col>
                  <v-col class="px-3">
                    <RepairCodeSelect v-model="editObject.RepairCodes" multiple returnobject  allowCreate clearable hideIcon :externaledit="editMode"
                      @FocusState="editMode ? null : editmodetrigger++">
                    </RepairCodeSelect>
                  </v-col>
                </v-row>
                <v-row no-gutters class="pb-2">
                  <v-col class="px-3">
                    <QAutoComplete v-model="editObject.JobCategoryId"
                      :label="$t('servicesystem.common_objects.job.job_category')" :list="jobCategoryList"
                      :textkey="'Name'" :valuekey="'Id'" clearable :externaledit="editMode"
                      @FocusState="editMode ? null : editmodetrigger++">
                    </QAutoComplete>
                  </v-col>
                  <v-col class="px-3">
                    <QCheckboxInput v-model="editObject.NoInvoice"
                      :label="$t('servicesystem.common_objects.job.notbillable')" :externaledit="editMode"
                      @FocusState="editMode ? null : editmodetrigger++">
                    </QCheckboxInput>
                  </v-col>
                </v-row>

                <edit-bar :externalTrigger="editMode" :saveable="valid && IsChanged"
                  :saveText="$t('servicesystem.common_objects.commonterms.save')" :dividerPos="'none'"
                  :class="editMode ? 'mt-1' : null" @saveEmit="save()" @modeEmit="editmodetrigger++">
                </edit-bar>
              </v-col>

            </v-row>
          </template>
        </slotted-card>
      </v-col>
      <v-divider vertical />
      <KPIOptions :childJobId="childjob.Id" :refreshTrigger="refreshKpiTrigger" />
    </v-row>
    <MachineConnectedJobsDialog :machine="childjob.Machine" :externaltrigger="jobsdialogtrigger">
    </MachineConnectedJobsDialog>
  </v-card>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import MachineConnectedJobsDialog from "@/components/Dialogs/MachineConnectedJobsDialog.vue";
import RepairCodeSelect from "@/components/Inputs/EntityDropdowns/RepairCodeSelect2.vue";
import SupplierFailureCodeSelect from "@/components/Inputs/EntityDropdowns/SupplierFailureCodeSelect2.vue";
import MachineLi from "@/components/ListItems/MachineListItem.vue";
import EditBar from "@/components/Sections/Editbar.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import KPIOptions from "@/views/job/viewjob/invoice/MachinejobKPIOptions.vue";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";

export default {
  name: "MachinejobInvoiceOptionsCard",
  props: {
    childjob: Object,
    repairCodes: Array,
    jobCategories: Array,
  },
  components: {
    MachineConnectedJobsDialog,
    EditBar,
    SlottedCard,
    KPIOptions,
    MachineLi,
    SupplierFailureCodeSelect,
    RepairCodeSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      editMode: false,
      editmodetrigger: 0,
      jobsdialogtrigger: 0,
      valid: false,
      editObject: {},
      refreshKpiTrigger: 1,
    };
  },

  mounted() {
    this.setEditObject();
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.OrderChange,
      this.notifyChanges
    ]);
  },

  beforeDestroy() {
    this.$store.dispatch("NotificationStore/unsubscribe", [
      SRConst.EventKeys.OrderChange,
      this.notifyChanges
    ]);
  },

  methods: {
    notifyChanges(args) {
      if (args && args.orderId) {
        if (args.orderId == this.OrderId) {
          //console.log("update entire order");
          this.$store.dispatch("JobHub/JobUpdater/triggerUpdateCompleteOrder");
        }
      }
    },

    updateValue(update) {
      this.editObject[update.key] = update.value;
    },

    save() {
      this.loading = true;
      const dto = Object.assign(this.editObject);

      clientAPI.methods.changeSubjob(dto)
        .then((response) => {
          this.$store.dispatch("JobHub/JobUpdater/UpdateSubjob", response);
          this.editmodetrigger++;
          this.$store.dispatch("JobHub/JobUpdater/triggerUpdateCompleteOrder");
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setEditMode(bool) {
      this.editMode = bool;
    },

    setValid(bool) {
      this.valid = bool;
    },

    setEditObject() {
      this.editObject = Object.assign({}, this.childjob);
    },

    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        this.editmodetrigger++;
      }
    },
  },

  computed: {
    IsChanged() {
      if (this.editObject && this.childjob) {
        return !this.SameValue(this.editObject, this.childjob);
      } else {
        return false;
      }
    },

    jobCategoryList() {
      return this.$store.getters["LookUpStore/JobCategoryList"];
    },

    OrderId() {
      return this.childjob.Order.Id;
    },

    ParentOrderId() {
      return this.$store.getters["JobHub/ParentOrder"]?.Id;
    },

    SupplierId() {
      var machine = this.childjob.Machine;
      var model = machine.MachineModel;
      return (machine && model && model.Supplier) ? model.Supplier.Id : undefined;
    },
    globalSettings() {
      return this.$store.state.GlobalSettings;
    }
  },

  watch: {
    childjob: {
      handler() {
        //console.log("childjob change");
        this.refreshKpiTrigger++;
        this.setEditObject();
      },
      deep: true,
    },

    editMode: function (val) {
      if (!val) {
        this.setEditObject();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>